import type { ReactNode } from "react";
import { useEffect, useState } from "react";
import { applyTheme, readTheme, type ThemeMode } from "../theme.ts";
import { useI18n } from "../i18n.tsx";

const NEXT: Record<ThemeMode, ThemeMode> = { auto: "light", light: "dark", dark: "auto" };
const ICON: Record<ThemeMode, ReactNode> = {
  auto: <svg viewBox="0 0 20 20" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.2"><circle cx="10" cy="10" r="7" /><path d="M10 3a7 7 0 0 1 0 14z" fill="currentColor" /></svg>,
  light: <svg viewBox="0 0 20 20" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"><circle cx="10" cy="10" r="3.4" /><path d="M10 2v2M10 16v2M2 10h2M16 10h2M4.3 4.3l1.4 1.4M14.3 14.3l1.4 1.4M4.3 15.7l1.4-1.4M14.3 5.7l1.4-1.4" /></svg>,
  dark: <svg viewBox="0 0 20 20" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.2"><path d="M16.5 11.5A7 7 0 0 1 8.5 3.5a7 7 0 1 0 8 8z" /></svg>,
};

export function ThemeToggle() {
  const { t } = useI18n();
  const [mode, setMode] = useState<ThemeMode>(readTheme);
  useEffect(() => { applyTheme(mode); }, [mode]);
  // In auto mode, keep the browser chrome colour in step with the system.
  useEffect(() => {
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const on = () => { if (mode === "auto") applyTheme("auto"); };
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, [mode]);
  const label = t(`theme.${mode}`);
  return (
    <button type="button" className="theme-toggle" onClick={() => setMode(NEXT[mode])} aria-label={`${t("theme.label")}: ${label}`} title={`${t("theme.label")}: ${label}`}>
      <span aria-hidden="true" style={{ display: "grid", placeItems: "center" }}>{ICON[mode]}</span>
    </button>
  );
}
